import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import Privacy from './pages/Privacy';
import TermsOfService from './pages/TermsOfService';
import NotReady from './pages/NotReady';
import Blog from './pages/Blog';
import SingleBlogPost from './pages/SingleBlogPost';
import EditBlogPost from './pages/EditBlogPost';
import BlogLoginPage from './pages/BlogLoginPage';
import AutoRegisterForm from './pages/AutoRegisterForm';
import Clarity from '@microsoft/clarity';
import CaseStudy from './pages/CaseStudy';
import CaseStudyStaldachBud from './pages/CaseStudyStaldachBud';
import CaseStudyHrCentre from './pages/CaseStudyHrCentre';
import Pricing from './pages/Pricing2';
import PracaTymczasowaOutsourcing from './pages/PracaTymczasowaOutsourcing';
import InzynieriaBudownictwo from './pages/InzynieriaBudownictwo';
import Kontakt from './pages/Kontakt';
import ONas from './pages/ONas';
import Home from './pages/Home';
import Funkcje from './pages/Funkcje';
import KalkulatorOszczednosci from './pages/KalkulatorOszczednosci';
import { initAnalytics, trackPageView, captureUtmParams } from './utils/analytics';
import { trackPageView as trackPageViewFirestore } from './utils/pageViewTracking';
import AppStore from './pages/AppStore';
import AdminPanel from './pages/AdminPanel';
import AdminPanelSession from './pages/AdminPanelSession';
import AdminPageViews from './pages/AdminPageViews';
import AdminPanelCalculator from './pages/AdminPanelCalculator';

const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
if (clarityProjectId && clarityProjectId.trim()) {
  Clarity.init(clarityProjectId.trim());
} else {
  console.warn("Clarity project ID is not set.");
}

captureUtmParams();
const gaMeasurementId = initAnalytics();

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
{
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/regulamin",
    element: <TermsOfService />,
  },
  {
    path: "/upss",
    element: <NotReady />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:id",
    element: <SingleBlogPost />,
  },
  {
    path: "/edit/:id",
    element: <EditBlogPost  />,
  },
  {
    path: "/login/blog",
    element: <BlogLoginPage   />,
  },
  {
    path: "/register/:step?",
    element: <AutoRegisterForm />,
  },
  {
    path: "/case-study",
    element: <CaseStudy />,
  },
  {
    path: "/case-study/staldach-bud",
    element: <CaseStudyStaldachBud />,
  },
  {
    path: "/case-study/hr-centre",
    element: <CaseStudyHrCentre />,
  },
  {
    path: "/cennik",
    element: <Pricing />,
  },
  {
    path: "/praca-tymczasowa-i-outsourcing",
    element: <PracaTymczasowaOutsourcing />,
  },
  {
    path: "/inzynieria-i-budownictwo",
    element: <InzynieriaBudownictwo />,
  },
  {
    path: "/o-nas",
    element: <ONas />,
  },
  {
    path: "/kontakt",
    element: <Kontakt />,
  },
  {
    path: "/funkcje",
    element: <Funkcje />,
  },
  {
    path: "/kalkulator-oszczednosci",
    element: <KalkulatorOszczednosci />,
  },
  {
    path: "/app",
    element: <AppStore/>
  },
  {
    path: "/admin-panel",
    element: <AdminPanel />
  },
  {
    path: "/admin-panel/page-views",
    element: <AdminPageViews />
  },
  {
    path: "/admin-panel/kalkulator",
    element: <AdminPanelCalculator />
  },
  {
    path: "/admin-panel/:sessionId",
    element: <AdminPanelSession />
  }

  // commented out so its not acessible to user on production
  // {
  //   path: "/app-old",
  //   element: <App />,
  // }
]);

const initialPath = `${router.state.location.pathname}${router.state.location.search || ""}`;
trackPageViewFirestore(initialPath);

if (gaMeasurementId) {
  trackPageView(initialPath);
}

router.subscribe((state) => {
  const nextPath = `${state.location.pathname}${state.location.search || ""}`;
  trackPageViewFirestore(nextPath);
  if (gaMeasurementId) {
    trackPageView(nextPath);
  }
});

// scripts/prerender.js bakes each route's fully-rendered HTML into the build, so
// crawlers and AI bots (which don't run JS) get the correct title/description and
// full article text. Real browsers run this bundle and do a clean client render,
// replacing the prerendered markup — we intentionally do NOT hydrate, because the
// app's runtime-dependent rendering (react-responsive, cookie consent, window
// access) doesn't byte-match the snapshot and would cause hydration errors.
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
